import { Button } from "@/components/ui/button";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";
import type { NewsEvent } from "@medical-association/shared";
import { useState } from "react";

const NewsManagement = () => {
	const [newsEvents, setNewsEvents] = useState<NewsEvent[]>([]);
	const [isAddingNew, setIsAddingNew] = useState(false);

	return (
		<div className="space-y-6">
			<div className="flex justify-between items-center">
				<h2 className="text-2xl font-semibold">News & Events Management</h2>
				<Button onClick={() => setIsAddingNew(true)}>Add New</Button>
			</div>

			<Table>
				<TableHeader>
					<TableRow>
						<TableHead>Title</TableHead>
						<TableHead>Category</TableHead>
						<TableHead>Date</TableHead>
						<TableHead>Status</TableHead>
						<TableHead>Actions</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{newsEvents.map((item) => (
						<TableRow key={item.id}>
							<TableCell>{item.title}</TableCell>
							<TableCell>{item.category}</TableCell>
							<TableCell>{item.date}</TableCell>
							<TableCell>{item.status}</TableCell>
							<TableCell>
								<Button variant="outline" size="sm">
									Edit
								</Button>
								<Button variant="destructive" size="sm">
									Delete
								</Button>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
};

export default NewsManagement;
